import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import jaLocale from 'element-ui/lib/locale/lang/ja'

Vue.use(VueI18n)

const initLang = localStorage.getItem("BLOCK_LANG") || process.env.VUE_APP_DEFAULT_LANG
// 注册i18n实例并引入语言文件，文件格式等下解析  
const i18n = new VueI18n({
  locale: initLang,
  messages: {
    'en': {
      ...require('../assets/lang/en').default,
      ...enLocale
    }, //与Element的语言包进行合并
    'zh': {
      ...require('../assets/lang/zh').default,
      ...zhLocale
    },
    'ja': {
      ...require('../assets/lang/ja').default,
      ...jaLocale
    }
  }
})

// switch (initLang) {
//   case "zh":
//     locale.use(zhLocale);
//     break;
//   case "ja":
//     locale.use(jaLocale);
//     break;
//   case "en":
//     locale.use(enLocale);
//     break;
//   default:
//     locale.use(zhLocale);
//     break;
// }

export default i18n